import { FC, useMemo } from "react";
import { Center, Text } from "@chakra-ui/react";

interface Props {
  isScheduleError: boolean;
  isDebtError: boolean;
}

export const PaymentsSchedulePageError: FC<Props> = ({ isScheduleError, isDebtError }) => {
  const message = useMemo(() => {
    let result = "данные";

    if (isScheduleError) {
      result = "график платежей";
    }

    if (isDebtError) {
      result = "информацию о задолженности";
    }

    return result;
  }, [isScheduleError, isDebtError]);

  return (
    <Center flex="1" flexDirection="column" mb="100px">
      <Text variant="brand">Не удалось загрузить</Text>
      <Text variant="brand" textAlign="center">{message}</Text>
    </Center>
  );
};
